import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'

import { settingsService } from '../services'

import type { UpdateHotGameFlexMessageDto } from '../../types'

interface UpdateFlexHotGameParams {
	id: string
	data: UpdateHotGameFlexMessageDto
}

const useMutationUpdateFlexHotGame = (
	baseQueryOptions?: UseBaseMutationOptions<unknown, UpdateFlexHotGameParams>,
) => {
	return useMutation({
		mutationFn: ({ id, data }: UpdateFlexHotGameParams) =>
			settingsService.updateFlexHotGame(id, data),
		...baseQueryOptions,
	})
}

export default useMutationUpdateFlexHotGame
